import type { SyncProgress } from '@tailorcast/shared-types';

interface SyncProgressBarProps {
  data: SyncProgress | undefined;
  isLoading: boolean;
}

export function SyncProgressBar({ data, isLoading }: SyncProgressBarProps) {
  if (isLoading || !data) return null;
  if (data.status === 'completed') {
    return (
      <div className="text-sm text-green-600">
        Sync complete: {data.processedItems} items processed ({data.newCount} new,{' '}
        {data.updatedCount} updated)
      </div>
    );
  }
  if (data.status === 'failed') {
    return <div className="text-sm text-red-600">Sync failed</div>;
  }
  if (data.status !== 'running' && data.status !== 'pending') return null;

  const percent = data.totalItems > 0 ? (data.processedItems / data.totalItems) * 100 : 0;

  return (
    <div>
      <div className="flex justify-between text-sm text-gray-600 mb-1">
        <span>Syncing catalog...</span>
        <span>
          {data.processedItems}/{data.totalItems}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-tailorcast-primary h-2 rounded-full transition-all"
          style={{ width: `${percent}%` }}
        />
      </div>
    </div>
  );
}
